import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createAboutus, fetchAboutus, fetchAboutusById, updateAboutus, } from "../../service/api";

export const getAboutus = createAsyncThunk(
    "about/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchAboutus(params)
            console.log("privacy", response)
            return response.data

        } catch (error) {
            return rejectWithValue(err.response.data || err.message)
        }
    }
)


export const getAboutusById = createAsyncThunk(
    "about/byId",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchAboutusById(params)
            console.log("about by id ", response)
            return response.data

        } catch (error) {
            return rejectWithValue(err.response.data || err.message)
        }
    }
)

export const addAboutus = createAsyncThunk(
    "about/add",
    async (params, { rejectWithValue }) => {

        try {
            const response = await createAboutus(params)
            console.log("privacy", response)

        } catch (error) {
            return rejectWithValue(err.response.data || err.message)
        }
    }
)

export const editAboutus = createAsyncThunk(
    "about/edit",
    async (params, { rejectWithValue }) => {

        try {
            const response = await updateAboutus(params)
            console.log("response", response)

        } catch (error) {
            return rejectWithValue(err.response.data || err.message)
        }
    }
)






const aboutSlice = createSlice({
    name: "abouts",
    initialState: {
        aboutList: [],
        aboutById: {},
        isLoading: false,
        actionLoader: false,
        error: null,

    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAboutus.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getAboutus.fulfilled, (state, action) => {
                state.isLoading = false,
                    state.aboutList = action.payload.data
                state.totalPage = action.payload.totalPages
            })
            .addCase(getAboutus.rejected, (state) => {
                state.isLoading = true,
                    state.error = null
            })

            //by id 
            .addCase(getAboutusById.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getAboutusById.fulfilled, (state, action) => {
                state.isLoading = false,
                    state.aboutById = action.payload.data
                state.totalPage = action.payload.totalPages
            })
            .addCase(getAboutusById.rejected, (state) => {
                state.isLoading = true,
                    state.error = null
            })

            //Post 

            .addCase(addAboutus.pending, (state) => {
                state.actionLoader = true
            })
            .addCase(addAboutus.fulfilled, (state, action) => {
                state.actionLoader = false

            })
            .addCase(addAboutus.rejected, (state) => {
                state.actionLoader = false
            })

            //put 

            .addCase(editAboutus.pending, (state) => {
                state.actionLoader = true
            })
            .addCase(editAboutus.fulfilled, (state, action) => {
                state.actionLoader = false

            })
            .addCase(editAboutus.rejected, (state) => {
                state.actionLoader = false
            })


    }
})

export default aboutSlice.reducer